import React from "react";
import { LineChart, MessageCircle, Repeat, ShieldCheck } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: MessageCircle,
    title: "Assessment & Setup",
    body:
      "A 20-min phone consult to map your history, schedule, recent training data and goal race.",
  },
  {
    n: "02",
    icon: LineChart,
    title: "Custom Build",
    body: (
      <>
        Your program is delivered fortnightly via{" "}
        <a
          href="#platform"
          onClick={(e) => {
            e.preventDefault();
            const el = document.getElementById("platform");
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}
          className="text-brand-red underline underline-offset-2 decoration-brand-red/40 hover:decoration-brand-red transition-colors"
        >
          Final Surge
        </a>
        , specific to your training zones, lifestyle and goals.
      </>
    ),
  },
  {
    n: "03",
    icon: Repeat,
    title: "1-1 Coaching",
    body:
      "Direct messaging via WhatsApp. Workout feedback. Weekly check-ins. Training adjustments.",
  },
  {
    n: "04",
    icon: ShieldCheck,
    title: "Race Execution",
    body:
      "Taper, fuelling plan and pacing strategy so race day is a confirmation, not a question.",
  },
];

export default function Methodology() {
  return (
    <section
      id="method"
      data-testid="method-section"
      className="relative py-24 lg:py-32 border-b border-white/10"
    >
      {/* Background kinetic word */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="marquee-track animate-marquee whitespace-nowrap absolute top-1/2 -translate-y-1/2">
          {Array.from({ length: 4 }).map((_, i) => (
            <span
              key={i}
              className="font-display outline-text text-[18vw] leading-none px-12"
            >
              PROCESS · PROCESS ·
            </span>
          ))}
        </div>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12">
          <div className="lg:col-span-3 flex items-start gap-4">
            <span className="font-mono text-brand-red text-xs tracking-widest">03</span>
            <span className="label-eyebrow">The Process</span>
          </div>
          <div className="lg:col-span-9">
            <h2 className="font-display uppercase text-white text-5xl lg:text-7xl leading-[0.9] tracking-tight max-w-3xl">
              A four-step system.
            </h2>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                data-testid={`method-step-${s.n}`}
                className={`relative p-8 lg:p-10 bg-[#0e0e10]/80 backdrop-blur-sm border-white/10 ${
                  i === 0 ? "border" : "border md:border-l-0"
                } group hover:bg-[#15151a] transition-colors`}
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="font-mono text-brand-red text-xs tracking-widest">{s.n}</span>
                  <Icon size={20} className="text-white/40 group-hover:text-brand-red transition-colors" />
                </div>
                <h3 className="font-display uppercase text-white text-2xl lg:text-3xl leading-tight tracking-wide">
                  {s.title}
                </h3>
                <p className="mt-4 text-sm text-white/65 leading-relaxed">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
